module.exports = "/static/assets/a37c0c0227061c4abe77f1dac93dd5b3.png";